import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/mailmagazine'

const Mailmagazine: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'内製化 内製化支援 Dev(Sec)Ops アジャイル開発 UIデザイン UXデザイン デザインスプリント'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/mailmagazine'}
        title="メールマガジン | Aitria（アイトリア）"
        description="Aitria（アイトリア）のメールマガジン登録ページです。UX/UIデザイン・システム内製化・DX推進についてのお役立ちメソッドや、限定イベント、最新事例などをお届けします。"
      />
      <Template />
    </>
  )
}

export default Mailmagazine
